module.exports = __webpack_public_path__ + "static/media/IN.b2ef0806.svg";